module.exports = __webpack_public_path__ + "static/media/contract_image.379177bb.png";